import type { AxiosRequestConfig } from 'axios'
import * as ChatBotType from './type'
import ChatBotService from './service'

export * from './init'
export * from './type'

export const useChatBotStore = defineStore('chatbot', () => {
  /**
   * 챗봇 시작
   */
  const chatBotOpening = async (payload: ChatBotType.ChatBotOpeningPayload) => {
    const { data } = await ChatBotService.chatBotOpening(payload)
    return data
  }
  /**
   * 챗봇과 채팅
   */
  const chatBotChattingPost = async (
    payload: ChatBotType.ChatBotChattingPostPayload,
    config?: AxiosRequestConfig
  ) => {
    const { data } = await ChatBotService.chatBotChattingPost(payload, config)
    return data
  }
  /**
   * 챗봇과 채팅 종료
   */
  const chatBotChattingClose = async (
    payload: ChatBotType.ChatBotClosingPayload
  ) => {
    const { data } = await ChatBotService.chatBotChattingClose(payload)
    return data
  }
  return {
    chatBotOpening,
    chatBotChattingPost,
    chatBotChattingClose,
  }
})
